import React, { useState, useMemo } from 'react';

// フィードバックの理由選択肢の定義
const FEEDBACK_REASONS = [
  {
    id: 'reason1',
    text: '意図した文書が見つからなかった'
  },
  {
    id: 'reason2',
    text: '関連性の低い文書が上位に表示された'
  },
  {
    id: 'reason3',
    text: 'どこをクリックすればいいか迷った'
  },
  {
    id: 'reason4',
    text: '検索フィルターの意味がわかりにくい'
  },
  {
    id: 'reason5',
    text: '表示に時間がかかった'
  },
  {
    id: 'other',
    text: 'その他'
  }
];

const BadReasonFeedbackPopup = ({ onClose, onBack, queryId, handleSubmit, isSubmitting = false }) => {
  // 初期状態のチェックボックス設定を選択肢から自動生成
  const initialCheckboxes = FEEDBACK_REASONS.reduce((acc, reason) => {
    acc[reason.id] = false;
    return acc;
  }, {});
  
  const [checkboxes, setCheckboxes] = useState(initialCheckboxes);
  const [otherReason, setOtherReason] = useState('');

  // 送信ボタンの有効/無効を判定
  const isSubmitDisabled = useMemo(() => {
    // 送信中は無効
    if (isSubmitting) {
      return true;
    }
    
    const hasSelectedReason = Object.values(checkboxes).some(checked => checked);
    
    // 何も選択されていない場合は無効
    if (!hasSelectedReason) {
      return true;
    }
    
    // 「その他」が選択されているが、テキストが空の場合は無効
    if (checkboxes.other && otherReason.trim() === '') {
      return true;
    }
    
    return false;
  }, [checkboxes, otherReason, isSubmitting]);

  const handleCheckboxChange = (name) => {
    setCheckboxes({
      ...checkboxes,
      [name]: !checkboxes[name]
    });
  };

  const handleTextareaChange = (e) => {
    setOtherReason(e.target.value);
  };

  // 内部のフォーム送信処理（親のhandleSubmitを呼び出す）
  const handleFormSubmit = (e) => {
    e.preventDefault();

    // 選択されたIDから対応するテキストを取得
    const selectedReasons = Object.keys(checkboxes)
      .filter(key => checkboxes[key])
      .map(id => {
        const reason = FEEDBACK_REASONS.find(r => r.id === id);
        return reason ? reason.text : id;
      });

    const feedbackData = {
      queryId,
      selectedReasons,
      otherReason: checkboxes.other ? otherReason : ''
    };

    // 親コンポーネントのhandleSubmitを呼び出し
    handleSubmit(feedbackData);

    // ポップアップを閉じる
    onClose();
  };

  return (
    <div className="feedback-popup wide">
       <button 
        className="close-button"
        onClick={onClose}
      >
      </button>
      
      <p className='message-main-title'>bad理由について、下記選択とご意見をいただければ幸いです。</p>
      <ul className='feedback-popup-checkbox-wrapper'>
        {FEEDBACK_REASONS.map((reason) => (
          <li key={reason.id} className='feedback-popup-checkbox-list'>
            <div className="company-checkbox-item c-justify-center">
              <label className='checkbox-native-box'>
                <input
                  className='checkbox-native'
                  type="checkbox"
                  checked={checkboxes[reason.id]}
                  onChange={() => handleCheckboxChange(reason.id)}
                  disabled={isSubmitting}
                />
              </label>
            </div>
            <p>{reason.text}</p>
          </li>
        ))}
      </ul>

      {/* その他にチェックが入っている場合のみテキストエリアを表示 */}
      {checkboxes.other && (
        <div className="other-reason-textarea">
          <h4 className='message-title'>上記選択した理由について</h4>
          <textarea
            placeholder="その他の理由をご記入ください"
            value={otherReason}
            onChange={handleTextareaChange}
            rows={4}
            className="message-area"
            disabled={isSubmitting}
          />
        </div>
      )}
      <div className="pop-buttons c-max-mini c-m-center">
        <button 
          type="button" 
          className="pop-btn button-secondary button-x-mini" 
          onClick={onBack}
          disabled={isSubmitting}
          style={{ opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
        >
          戻る
        </button>
        <button 
          className={`pop-btn btn-primary button-x-mini ${isSubmitDisabled ? 'disabled' : ''}`}
          onClick={handleFormSubmit}
          disabled={isSubmitDisabled}
          style={{ opacity: isSubmitDisabled ? 0.6 : 1, cursor: isSubmitDisabled ? 'not-allowed' : 'pointer' }}
        >
          {isSubmitting ? '送信中...' : '送信する'}
        </button>
      </div>
    </div>
  );
};

export default BadReasonFeedbackPopup;